import { render } from "./PanelHeader.vue?vue&type=template&id=050801e6&scoped=true"
import script from "./PanelHeader.vue?vue&type=script&lang=js"
export * from "./PanelHeader.vue?vue&type=script&lang=js"

import "./PanelHeader.vue?vue&type=style&index=0&id=050801e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050801e6"]])

export default __exports__